<div class="message-container" fxLayout="row" *ngIf="error">
    <span><i class="fa fa-exclamation-circle"></i></span>
    <span [innerHTML]="error"></span>
</div>